
import { sample } from 'lodash';
import { createContext } from 'react';

const defaultContextValue = {
   productId: '',
        articleName: null,
        articleCode: null,
        description: '',
        supplier: '',
        isCreateBarcode: true,
        createBatch: false,
        hsnCode: '',
        mappedFabric: [],
        tags: [],
        metrics: {
            weight: 0,
            thickness: 0,
            length: 0,
            width: 0,
            inches: 0,
            centimeter: 0,
            meter: 0,
            meterSqKg: 0,
        },
        otherInformation: {
            skuPrefix: '',
            coneWeight: '',
            unitOfMeasures:
            {
                type: 'UOM',
                isRoll: true,
                isKg: false,
                isMeter: false,
                isYard: false,
            }
        },
        prodVariants: {

        },
        productVariants: [

        ],
        productCategories: {

        },
        newProductVariants: [],
        fabricContent: {
            value: "",
            composition: {}
        },
        totalProductPercent: 0,
        priceSetting: {
            isMarkUp: false,
            isMarkDown: false,
            costPrice: 0,
            markUpPercent: 0,
            markDownPercent: 0,
            sellingPrice: 0,
            mrp: 0,
            margin: 0,
        },
        categoryId: '',
        gstId: '',
        brandId: '',
        seasonId: '',
        taxonomyNode: {},
        vendorProductInfo: {
            vendorId: '',
            productId: '',
            leadTime: '',
            grayLeadTime: '',
            fabricLeadTime: '',
            costPrice: 0,
            vendorProductId: '',
            vendorProductName: '',
            supplier: '',
    status: 'ACTIVE',
  },
  handleChange: () => {},
  addProduct: async () => {},
  setProduct: () => {},
  imageFile: null,
  setImageFile: () => {},
  inputError: {},
  setInputError: () => {},
  setHasMultiSelectCategoryMandatory: () => {},
};

export const MappedProductContext = createContext(defaultContextValue);